import React, { useLayoutEffect } from "react";
import { BrookshireBrotherLogoWithTagline, KSOPBrochure } from "../../../../../assets";
import CoreKsopImage from "../../../../../assets/CorePlanImages/CoreKsopImage.avif";
import "./ksop.scss";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";

const KSOP: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<div className="ksop-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">KSOP Plan</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={BrookshireBrotherLogoWithTagline} alt="" />
					</div>
					<div className="plan-description">
						<ul>
							<li>Must be 18 years of age or older</li>
							<li>Must have at least one full year of working hours with Brookshire Brothers</li>
							<li>Can contribute 1% to 15% of pay – payroll deducted</li>
							<li>
								Brookshire Brothers matches $0.50 on the dollar for the first 6% contributed by the
								Participant
							</li>
							<li>
								The match made by the company (Brookshire Brothers) is made in ESOP shares, and the
								shares are contributed to the employee’s ESOP account. The match is not made into the
								employee’s 401(k) account. ESOP = Employee Stock Ownership Plan
							</li>
							<li>
								Participants can only change their contribution rate during open enrollment periods –
								held every April and October.
							</li>
							<li>Investments can be changed at any time</li>
							<li>
								For general ESOP or 401(k) questions, or plan documents, employees need to contact
								Jennifer Robertson, in HR. (936) 634-8155, ext. 4212
							</li>
							<li>
								If employees want to enroll in 401(k) or change their account settings, they can do so
								at www.principal.com or call 1-800-547-7754, refer to contract # 521021.
							</li>
						</ul>
					</div>
				</div>
				<div className="right-section">
					<img src={CoreKsopImage} alt="CoreKsopImage" />
				</div>
			</div>
			<h3 className="sub-heading-title">Plan Brochure</h3>

			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={KSOPBrochure} />
			</div>
		</div>
	);
};

export default KSOP;
